var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefendantRelations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.8708,
    cy: 23.775,
    r: 21.8327,
    fill: "white",
    stroke: "#8C0086",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8492_10606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3279 21.346L31.5013 28.5534C32.3009 29.3501 32.3009 30.6404 31.5013 31.4362C31.1171 31.8182 30.5973 32.0327 30.0555 32.0327C29.5137 32.0327 28.9939 31.8182 28.6098 31.4362L21.4131 24.2608",
    stroke: "#8C0086",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5273 20.3744L21.4138 24.2608",
    stroke: "#8C0086",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3278 21.346L20.4414 17.4596",
    stroke: "#8C0086",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6123 32.0337H21.4135",
    stroke: "#8C0086",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.297 26.9745L14.8128 23.4904C14.6306 23.3081 14.5283 23.0611 14.5283 22.8034C14.5283 22.5458 14.6306 22.2987 14.8128 22.1165L17.0407 19.8886L17.5265 20.3744L20.4413 17.4596L19.9555 16.9738L22.1834 14.7459C22.3656 14.5638 22.6127 14.4614 22.8703 14.4614C23.128 14.4614 23.375 14.5638 23.5572 14.7459L27.0414 18.2301C27.2236 18.4123 27.3259 18.6594 27.3259 18.917C27.3259 19.1746 27.2236 19.4217 27.0414 19.6039L24.8135 21.8318L24.3277 21.346L21.4129 24.2608L21.8987 24.7466L19.6708 26.9745C19.4886 27.1567 19.2415 27.259 18.9839 27.259C18.7263 27.259 18.4792 27.1567 18.297 26.9745Z",
    stroke: "#8C0086",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8492_10606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3185,
    height: 23.3185,
    fill: "white",
    transform: "translate(11.6973 11.63)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefendantRelations);
export default __webpack_public_path__ + "static/media/defendant-relations.fd8adae7e6ec30c915400512b5e126ed.svg";
export { ForwardRef as ReactComponent };